import { CodeContextGroup, CommandType, getCommandCodeContextGroup } from '~/constants/commands'
import { ProjectSelectionOption } from '~/store/taskFormSlice'

// Declarative command mapping configuration
const COMMAND_MAPPING = {
  [CodeContextGroup.DATAWEAVE]: {
    none: CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION,
    codeContext: CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE,
    upload: CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE,
    mappingTable: CommandType.GENERATE_DATAWEAVE
  },
  [CodeContextGroup.INTEGRATION]: {
    none: CommandType.GENERATE_ADD_FLOW_CODE_PR,
    codeContext: CommandType.GENERATE_REPO_ADD_FLOW_CODE_PR,
    upload: CommandType.GENERATE_REPO_ADD_FLOW_CODE_PR
  },
  [CodeContextGroup.SAMPLE_DATA]: {
    none: CommandType.DATAWEAVE_TO_DATA_CREATION,
    codeContext: CommandType.DATAWEAVE_TO_DATA_CREATION_REPO_AWARE,
    upload: CommandType.DATAWEAVE_TO_DATA_CREATION_REPO_AWARE
  }
} as const

// Groups that support 'none' option (no repository)
const NO_REPOSITORY_GROUPS = [
  CodeContextGroup.DATAWEAVE,
  CodeContextGroup.INTEGRATION,
  CodeContextGroup.SAMPLE_DATA,
  CodeContextGroup.CODE_ENHANCER
]

// Special command option overrides
const COMMAND_OPTION_OVERRIDES = {
  [CommandType.GENERATE_MAPPING_TABLE]: 'none' as const,
  [CommandType.GENERATE_DATAWEAVE]: 'mappingTable' as const
}

export const getCommandGroup = (command: CommandType): CodeContextGroup | string => {
  return getCommandCodeContextGroup(command) || ''
}

export const resolveCommandFromOption = (
  group: CodeContextGroup | string,
  option: ProjectSelectionOption
): CommandType | undefined => {
  const mapping = COMMAND_MAPPING[group as keyof typeof COMMAND_MAPPING]
  return mapping?.[option as keyof typeof mapping]
}

export const shouldUpdateOption = (
  initialCommand: CommandType,
  currentOption: ProjectSelectionOption,
  group: CodeContextGroup | string
): ProjectSelectionOption | null => {
  // Special case overrides
  const override = COMMAND_OPTION_OVERRIDES[initialCommand as keyof typeof COMMAND_OPTION_OVERRIDES]
  if (override) return override

  // DataWeave group doesn't support mappingTable unless it's specifically a DataWeave command
  if (currentOption === 'mappingTable' && group !== CodeContextGroup.DATAWEAVE) {
    return 'upload'
  }

  // Commands that don't support 'none' repository should default to 'upload' or 'codeContext'
  if (
    !NO_REPOSITORY_GROUPS.includes(group as CodeContextGroup) &&
    !['upload', 'codeContext'].includes(currentOption)
  ) {
    return 'upload'
  }

  return null
}
